/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddToWatchlistRequest } from '../models/AddToWatchlistRequest';
import type { api__schemas__integrations__watchlist__WatchlistResponse } from '../models/api__schemas__integrations__watchlist__WatchlistResponse';
import type { RemoveFromWatchlistResponse } from '../models/RemoveFromWatchlistResponse';
import type { ResearchAllRequest } from '../models/ResearchAllRequest';
import type { ResearchAllResponse } from '../models/ResearchAllResponse';
import type { ResearchStatusResponse } from '../models/ResearchStatusResponse';
import type { ScheduleConfigResponse } from '../models/ScheduleConfigResponse';
import type { UpdateScheduleRequest } from '../models/UpdateScheduleRequest';
import type { UpdateWatchlistItemRequest } from '../models/UpdateWatchlistItemRequest';
import type { WatchlistItemResponse } from '../models/WatchlistItemResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WatchlistService {
    /**
     * Get Watchlist
     * Get user's watchlist with tier info.
     *
     * Returns all active watchlist items, the tier limit (5 for free, 20 for pro),
     * and whether the user can add more items.
     * @returns api__schemas__integrations__watchlist__WatchlistResponse Successful Response
     * @throws ApiError
     */
    public static getWatchlistApiV1WatchlistGet(): CancelablePromise<api__schemas__integrations__watchlist__WatchlistResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/watchlist',
        });
    }
    /**
     * Add To Watchlist
     * Add a ticker to the user's watchlist.
     *
     * Respects tier limits (Free: 5, Pro: 20).
     * If the ticker already exists, updates it instead.
     * @returns WatchlistItemResponse Successful Response
     * @throws ApiError
     */
    public static addToWatchlistApiV1WatchlistPost({
        requestBody,
    }: {
        requestBody: AddToWatchlistRequest,
    }): CancelablePromise<WatchlistItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/watchlist',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Remove From Watchlist
     * Remove a ticker from the user's watchlist.
     *
     * Soft deletes the item (sets is_active=False).
     * @returns RemoveFromWatchlistResponse Successful Response
     * @throws ApiError
     */
    public static removeFromWatchlistApiV1WatchlistTickerDelete({
        ticker,
    }: {
        ticker: string,
    }): CancelablePromise<RemoveFromWatchlistResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/watchlist/{ticker}',
            path: {
                'ticker': ticker,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Watchlist Item
     * Update a watchlist item.
     *
     * Can update notes, priority, and research_enabled flag.
     * @returns WatchlistItemResponse Successful Response
     * @throws ApiError
     */
    public static updateWatchlistItemApiV1WatchlistTickerPatch({
        ticker,
        requestBody,
    }: {
        ticker: string,
        requestBody: UpdateWatchlistItemRequest,
    }): CancelablePromise<WatchlistItemResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/watchlist/{ticker}',
            path: {
                'ticker': ticker,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Schedule Config
     * Get scheduled research configuration.
     *
     * Only Pro users can enable scheduled research, but all users
     * can view their config (will show as disabled for free users).
     * @returns ScheduleConfigResponse Successful Response
     * @throws ApiError
     */
    public static getScheduleConfigApiV1WatchlistScheduleGet(): CancelablePromise<ScheduleConfigResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/watchlist/schedule',
        });
    }
    /**
     * Update Schedule Config
     * Update scheduled research configuration.
     *
     * Requires Pro subscription to enable scheduling.
     * @returns ScheduleConfigResponse Successful Response
     * @throws ApiError
     */
    public static updateScheduleConfigApiV1WatchlistSchedulePut({
        requestBody,
    }: {
        requestBody: UpdateScheduleRequest,
    }): CancelablePromise<ScheduleConfigResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/watchlist/schedule',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Start Research All
     * Start 'Research All' on watchlist symbols.
     *
     * Requires Pro subscription. Creates a job and researches each ticker
     * using deep research with LEAPS and deep thinking enabled.
     *
     * Progress is streamed via SSE at /api/v1/jobs/{job_id}/stream.
     * @returns ResearchAllResponse Successful Response
     * @throws ApiError
     */
    public static startResearchAllApiV1WatchlistResearchPost({
        requestBody,
    }: {
        requestBody: ResearchAllRequest,
    }): CancelablePromise<ResearchAllResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/watchlist/research',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Research Status
     * Get latest research job status.
     *
     * Returns the most recent job and a list of recent jobs.
     * @returns ResearchStatusResponse Successful Response
     * @throws ApiError
     */
    public static getResearchStatusApiV1WatchlistResearchStatusGet(): CancelablePromise<ResearchStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/watchlist/research/status',
        });
    }
}
